// initial state
const state = {
    visible: false,
    title: '',
    handlerAction: null,
    handlerActionParams: null,
    cancelAction: null,
    cancelActionParams: null
};

// mutations
const mutations = {
    show(state) {
        state.visible = true;
    },
    hide(state) {
        state.visible = false;
    },
    title(state, title) {
        state.title = title;
    },
    handlerAction(state, handlerAction) {
        state.handlerAction = handlerAction;
    },
    handlerActionParams(state, handlerActionParams) {
        state.handlerActionParams = handlerActionParams;
    },
    cancelAction(state, cancelAction) {
        state.cancelAction = cancelAction;
    },
    cancelActionParams(state, cancelActionParams) {
        state.cancelActionParams = cancelActionParams;
    }
};

// actions
const actions = {
    open(store, payload) {
        store.commit('title', payload.title);
        store.commit('handlerAction', payload.handlerAction);
        store.commit('handlerActionParams', payload.handlerActionParams);
        store.commit('cancelAction', payload.cancelAction);
        store.commit('cancelActionParams', payload.cancelActionParams);
        store.commit('show');
    },
    hide(store) {
        if (store.state.cancelAction) {
            store.dispatch(store.state.cancelAction, store.state.cancelActionParams, { root: true });
        }
        store.commit('hide');
    },
    ok(store) {
        store.dispatch(store.state.handlerAction, store.state.handlerActionParams, { root: true });
        store.commit('hide');
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/confirmation.js